import { Sparks } from 'iconoir-react';
import { FC } from 'react';

import { Badge } from '@savgroup-front-common/primitive/ui/badge';

import { SafeFormattedMessageWithoutSpread } from '../../../formatters/SafeFormattedMessageWithoutSpread';

import messages from './messages';

interface ProposedValueBadgeProps {
  isProposed: boolean;
  dataTestId?: string;
}

export const ProposedValueBadge: FC<ProposedValueBadgeProps> = ({
  isProposed,
  dataTestId,
}) => {
  if (!isProposed) {
    return undefined;
  }

  return (
    <Badge variant="subtle" data-testid={dataTestId}>
      <Sparks aria-hidden />
      <SafeFormattedMessageWithoutSpread message={messages.proposed} />
    </Badge>
  );
};
